import classnames from "classnames";
import * as React from "react";
import { matchPath as defaultMatchPath, useLocation } from "react-router-dom";

import RouteTransitionWrapper from "features/common/paging/components/RouteTransitionWrapper";

import ModalWrapper from "./ModalWrapper";

type Props = {
  children: React.ReactNode;
  backLink?: string;
  onBackClick?: () => void;
  className?: string;
  baseLink?: string;
  baseLinks?: string[];
  matchPath?: typeof defaultMatchPath;
  zIndex?: number;
};

export default function ModalJourneyWrapper({
  baseLink,
  baseLinks = [],
  children,
  backLink,
  onBackClick,
  className,
  matchPath = defaultMatchPath,
  zIndex = 10
}: Props) {
  const links = baseLink ? [...baseLinks, baseLink] : baseLinks;

  const location = useLocation();

  const currentLocationIsInJourney = links.some(
    link =>
      !!matchPath(location.pathname, {
        path: link,
        exact: false
      })
  );

  if (!currentLocationIsInJourney) {
    return null;
  }

  return (
    <ModalWrapper
      backLink={backLink}
      onBackClick={onBackClick}
      zIndex={zIndex}
      renderTransitionWrapper={({ className: wrapperClass }) => (
        <RouteTransitionWrapper
          location={location}
          className={classnames(wrapperClass, className)}
        >
          {children}
        </RouteTransitionWrapper>
      )}
    />
  );
}
